import {authenticate} from '@simpleinvest/front-end-auth';
// eslint-disable-next-line import/no-cycle
import ssoService from '@client/services/sso';
import baseUrl from '@client/util/baseUrl';
import {getSsoRedirectUri} from '@client/util/ssoRedirect';
import {onboardingGoingLiveBeforeServicing} from '@client/remote-config';

const onboardingLiveBeforeServicing = async () => {
  const onboardingBeforeServicing = await onboardingGoingLiveBeforeServicing();

  return onboardingBeforeServicing;
};

const stateObj = {
  user: null,
  ssoLoginResponse: null,
};

const mutations = {
  setUser(state, user) {
    // eslint-disable-next-line no-param-reassign
    state.user = user;
  },
  SET_SSO_LOGIN_RESPONSE(state, data) {
    state.ssoLoginResponse = data;
  },
};

const actions = {
  async authenticateUser(context, {riaId, email, password}) {
    const user = await authenticate({
      clientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
      email,
      env: process.env.VUE_APP_ENV,
      password,
      riaId,
    });

    context.commit('setUser', user);

    return user;
  },
  setUser(context, user) {
    context.commit('setUser', user);
  },
  async ssoLogin({commit, getters}) {
    const riaId = process.env.VUE_APP_ENV === 'local' ? process.env.VUE_APP_RIA_ID : null;
    const riaLoginUrl = process.env.VUE_APP_ENV === 'local' ? process.env.VUE_APP_HOST : window.location.hostname;
    const payload = {
      riaLoginUrl,
      ssoAlias: getters.ssoAlias,
      riaId,
    };

    const {data} = await ssoService.cognitoSsoLogin(payload);

    commit('SET_SSO_LOGIN_RESPONSE', data);

    return data;
  },
};

const gettersObj = {
  username: (state) => (state.user === null ? null : state.user.username),
  groups: (state) => (state.user === null ? [] : state.user.groups),
  enterpriseId: (state) => (state.user === null ? null : state.user.enterpriseId),
  riaId: (state) => (state.user === null ? null : state.user.riaId),
  userId: (state) => (state.user === null ? null : state.user.userId),
  userType: (state) => (state.user === null ? null : state.user.userType),
  preferredUsername: (state) => (state.user === null ? null : state.user.preferredUsername),
  email: (state) => (state.user === null ? null : state.user.email),
  ssoLoginResponse: (state) => state.ssoLoginResponse || null,
  getRedirectUrl: async (state) => {
    if (state.ssoLoginResponse.userType === 'cdo_user' && state.ssoLoginResponse.featureStatus) {
      return `${baseUrl.internal()}/client/${state.ssoLoginResponse.linkAlias}/getstarted`;
    }

    if (state.ssoLoginResponse.userType === 'cl_user') {
      let redirectUri;

      if (await onboardingLiveBeforeServicing()) {
        redirectUri =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      } else {
        redirectUri = '/clientdashboard';

        redirectUri += getSsoRedirectUri();

        redirectUri = `${baseUrl.internal()}${redirectUri}`;
      }

      return redirectUri;
    }

    return `${baseUrl.internal()}`;
  },
  ssoAlias: (state, getters) => {
    const principalSimpleInvestSsoAlias = 'principal-simple-invest';
    const groupToSsoAliasMap = new Map()
      .set(`${process.env.VUE_APP_COGNITO_USERPOOL_ID}_Auth0-SimpleInvest`, principalSimpleInvestSsoAlias)
      .set(`${process.env.VUE_APP_COGNITO_USERPOOL_ID}_Principal-SimpleInvest`, principalSimpleInvestSsoAlias);
    const {groups} = getters;
    let ssoAlias = null;

    groups.forEach((group) => {
      if (groupToSsoAliasMap.has(group)) {
        ssoAlias = groupToSsoAliasMap.get(group);
      }
    });

    return ssoAlias;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  mutations,
  actions,
  getters: gettersObj,
};
